export enum SaveEntityStatus {
    None = 'None',
    Pending = 'Pending',
    Saved = 'Saved',
    Error = 'Error',
}

export interface IModifiedInfo {
    modifiedAt: Date;
    modifiedBy: string;
}

export interface IBaseEntityState {
    baseJsonString: string | null;
    currentJsonString: string | null;
    isChanged: boolean | undefined;

    saveStatus: SaveEntityStatus;

    modified?: IModifiedInfo;
}

export function clearBaseEntityState(state: IBaseEntityState) {
    state.baseJsonString = null;
    state.currentJsonString = null;
    state.isChanged = undefined;
    state.saveStatus = SaveEntityStatus.None;

    state.modified = undefined;
}

export function setBaseEntityCurrentJson(state: IBaseEntityState, currentJson: string, setAsBaseline: boolean) {
    state.currentJsonString = currentJson;

    if (setAsBaseline) {
        state.baseJsonString = state.currentJsonString;
    }

    if (state.baseJsonString === null && state.currentJsonString === null) {
        state.isChanged = undefined;
    }

    state.isChanged = state.currentJsonString !== state.baseJsonString;
}

export function compareModifiedDate(checkObj: any, modified: IModifiedInfo | undefined): IModifiedInfo | undefined {
    if (checkObj && checkObj.modified) {
        if (!modified || modified.modifiedAt < checkObj.modified) {
            return {
                modifiedAt: checkObj.modified,
                modifiedBy: checkObj.modifiedBy,
            };
        }
    }

    return modified;
}

export type IndexedValidation = { index: number; valid: boolean };
